import OAuthScopesInput_vue_vue_type_script_setup_true_lang_default from "./OAuthScopesInput.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                     */
//#region src/v2/blocks/scalar-auth-selector-block/components/OAuthScopesInput.vue
var OAuthScopesInput_default = OAuthScopesInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { OAuthScopesInput_default as default };

//# sourceMappingURL=OAuthScopesInput.vue.js.map